import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModeloDepositoMS } from 'src/app/open-api';

@Component({
  selector: 'app-deposito-detalle',
  templateUrl: './deposito-detalle.component.html',
  styleUrls: ['./deposito-detalle.component.scss']
})
export class DepositoDetalleComponent implements OnInit {

  @Input() deposito?: ModeloDepositoMS;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

}
